import React, { useEffect, useRef, useState } from "react";

function Musicas() {
  const [musicas, setMusicas] = useState([]);
  const [form, setForm] = useState({});
  const [tocandoId, setTocandoId] = useState(null);
  const audioRef = useRef(new Audio());

  // ==============================
  // LISTAR MÚSICAS
  // ==============================
  useEffect(() => {
    fetch("https://videooferta.com/api/listar_musicas.php", {
      method: "POST"
    })
      .then(res => res.json())
      .then(data => setMusicas(data))
      .catch(err => console.error(err));

    return () => {
      audioRef.current.pause();
    };
  }, []);

  // ==============================
  // PLAY / PAUSE
  // ==============================
  function togglePlay(musica) {
    const audio = audioRef.current;

    // pausa se clicar na mesma música
    if (tocandoId === musica.id) {
      audio.pause();
      setTocandoId(null);
      return;
    }

    // troca de música
    audio.src = musica.url;
    audio.play();
    setTocandoId(musica.id);

    audio.onended = () => {
      setTocandoId(null);
    };
  }

  // ==============================
  // ATUALIZA FORM
  // ==============================
  function handleChange(e) {
    const { name, value, files } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  }

  // ==============================
  // SALVAR MÚSICA
  // ==============================
  function salvar(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("titulo", form.titulo || "");
    if (form.musica instanceof File) {
      formData.append("musica", form.musica);
    }

    fetch("https://videooferta.com/api/cadastrar_musica.php", {
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "ok") {
          alert(data.msg);
          setForm({});
          setMusicas(prev => [...prev, data.musica]);
        } else {
          alert("Erro: " + data.msg);
          console.error(data.erro);
        }
      })
      .catch(err => {
        console.error(err);
        alert("Erro ao comunicar com o servidor");
      });
  }

  return (
    <div className="row">
      {/* LISTAGEM */}
      <div className="col-6">
        <h5>Músicas</h5>

        <table className="table table-bordered small align-middle small">
          <thead>
            <tr>
              <th>ID</th>
              <th>Música</th>
            </tr>
          </thead>
          <tbody>
            {musicas.map(m => (
              <tr key={m.id}>
                <td>{m.id}</td>
                <td className="d-flex align-items-center gap-2">
                  <button
                    className={`btn btn-sm ${
                      tocandoId === m.id
                        ? "btn-success"
                        : "btn-primary"
                    }`}
                    onClick={() => togglePlay(m)}
                  >
                    <i
                      className={`fas ${
                        tocandoId === m.id ? "fa-pause" : "fa-play"
                      }`}
                    ></i>
                  </button>

                  <span>{m.titulo}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* FORM */}
      <div className="col-6">
        <h5>Cadastrar Música</h5>

        <form onSubmit={salvar} encType="multipart/form-data">
          <div className="mb-2">
            <label>Título</label>
            <input
              className="form-control"
              name="titulo"
              value={form.titulo || ""}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-2">
            <label>Arquivo de Música</label>
            <input
              type="file"
              className="form-control"
              name="musica"
              onChange={handleChange}
              accept="audio/*"
              required
            />
          </div>

          <button className="btn btn-primary w-100">
            Salvar Música
          </button>
        </form>
      </div>
    </div>
  );
}

export default Musicas;
